import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import {
  GET_DYNAMIC_DATA,
  ADD_NEW_DYNAMIC_DATA,
  UPDATE_DYNAMIC_DATA,
  DELETE_DYNAMIC_DATA,
  
} from "./actionTypes"

import {
  getDynamicDataSuccess,
  addDynamicDataSuccess,
  updateDynamicDataSuccess,
  deleteDynamicDataSuccess,
  dynamicDataApiError

} from "./actions"

//Include Both Helper File with needed methods
import {

  
  getDynamicData,
  addNewDynamicData,
  updateDynamicData,
  deleteDynamicData,


} from "../../../helpers/backend_helper/backend_helper"

//INTEGRATİON


function* fetchDynamicData( { payload: url } ) {
  try {
    const response = yield call(getDynamicData, url)
    yield put(getDynamicDataSuccess(response))
  } catch (error) {
    yield put(dynamicDataApiError(error))
  }
}

function* onAddNewDynamicData({url: url, payload: dynamicData }) {
  try {
    const response = yield call(addNewDynamicData, url, dynamicData)
    yield put(addDynamicDataSuccess(response))
  } catch (error) {

    yield put(dynamicDataApiError(error))
  }
}

function* onUpdateDynamicData( { url: url, payload: dynamicData }) {
  try {
    const response = yield call(updateDynamicData, url, dynamicData)
    yield put(updateDynamicDataSuccess(response))
  } catch (error) {
    yield put(dynamicDataApiError(error))
  }
}

function* onDeleteDynamicData({ url: url, payload: guid }) {
  try {
    const response = yield call(deleteDynamicData, url, guid)
    yield put(deleteDynamicDataSuccess(response))
  } catch (error) {
    yield put(dynamicDataApiError(error))
  }
}


export function* watchDynamicListData() {
  yield takeEvery(GET_DYNAMIC_DATA,fetchDynamicData)
  yield takeEvery(ADD_NEW_DYNAMIC_DATA,onAddNewDynamicData)
  yield takeEvery(UPDATE_DYNAMIC_DATA,onUpdateDynamicData)
  yield takeEvery(DELETE_DYNAMIC_DATA,onDeleteDynamicData)
}

function* dynamicListSaga() {
  yield all([fork(watchDynamicListData)])
}

export default dynamicListSaga
